import { MonthPick } from './MonthPick';

/**
 * THE MONTH, ON A PHONE — the boards put the period in the title ("Tax · Aug
 * 2026"), so the strip is only the chips: the branch line the desk row adds
 * is dropped, and the row scrolls sideways rather than wrapping.
 */
export function PhonePeriod({ period, onChange }: { period: string; onChange: (next: string) => void }) {
  return (
    <div className="filterrow acc-phone-period">
      <MonthPick period={period} onChange={onChange} />
    </div>
  );
}
